// Mock data para Your Broker Portugal - Atualizado

export const companyInfo = {
  name: 'Your Broker Portugal',
  tagline: 'Parceiros imobiliários globais em Portugal Continental',
  hero: {
    title: 'Todas as agências numa só',
    subtitle: 'Encontramos o seu imóvel de sonho em Portugal, com acesso a todo o mercado e uma curadoria exclusiva adaptada ao seu perfil.',
    description: 'Na Your Broker Portugal atuamos como consultores do comprador, representando exclusivamente os seus interesses. Temos acesso a todo o mercado imobiliário nacional, incluindo promotores, agências e proprietários particulares. O nosso trabalho é compreender o seu estilo de vida, o que procura e o seu orçamento, para depois apresentar uma seleção criteriosa dos imóveis que realmente fazem sentido para si. Negociamos em seu nome, organizamos as visitas privadas e acompanhamos todo o processo até à assinatura final. Tudo isto sem qualquer custo para o comprador — a nossa remuneração é assegurada pelos nossos parceiros.',
    cta: 'Solicite um contacto e descubra como podemos encontrar o imóvel certo para si.',
    quote: 'Mais de três décadas de experiência internacional no mercado imobiliário ao seu serviço.',
    author: 'Your Broker Portugal Team'
  },
  stats: [
    { value: '30+', label: 'Anos de experiência' },
    { value: '100%', label: 'Foco no comprador' },
    { value: 'Portugal', label: 'Cobertura nacional' }
  ],
  about: {
    title: 'Sobre Nós',
    paragraphs: [
      'A Your Broker Portugal nasceu da experiência internacional de mais de três décadas no mercado imobiliário, aliando profundo conhecimento do setor português a uma atuação diferenciada no atendimento a compradores. O nosso compromisso é colocar o cliente no centro do processo, garantindo uma pesquisa completa e imparcial em todo o mercado.',
      'Ao contrário das agências tradicionais, que representam vendedores, trabalhamos exclusivamente do lado do comprador, oferecendo uma visão clara, transparente e objetiva de cada oportunidade. A nossa rede de contactos inclui promotores, agências licenciadas AMI e proprietários privados em todo o país, permitindo-nos apresentar soluções únicas e personalizadas.',
      'Somos uma empresa familiar que alia profissionalismo, discrição e confiança. O nosso objetivo é simples: que cada cliente encontre em Portugal não apenas um imóvel, mas o lugar certo para viver, investir ou desfrutar da sua segunda casa.'
    ]
  },
  contact: {
    phone: '+351 931 997 415',
    email: 'portugal@yourbrokerportugal.com',
    whatsapp: '+351931997415',
    company: 'Your Broker Portugal, Lda.',
    nipc: '516 549 642',
    ami: 'AMI 19715'
  }
};

export const regions = [
  {
    id: 1,
    name: 'Lisboa Prime',
    description: 'No coração da capital, Lisboa Prime reúne bairros icónicos como Chiado, Príncipe Real, Avenida da Liberdade e Lapa. Aqui encontram-se imóveis únicos, desde palácios reabilitados a apartamentos contemporâneos em edifícios históricos. O valor médio ronda os €8.000 a €12.000/m², atraindo clientes que procuram sofisticação, património e a energia cosmopolita da cidade.',
    image: 'https://images.unsplash.com/photo-1534317238742-f89a245f5c83?w=1200&q=80',
    priceRange: '€8.000 - €12.000/m²'
  },
  {
    id: 2,
    name: 'Linha de Cascais & Oeiras',
    description: 'Entre o mar e a vida urbana, Cascais, Estoril e Oeiras oferecem um estilo de vida descontraído com proximidade a Lisboa. Vistas oceânicas, campos de golfe, marinas e escolas internacionais fazem desta região uma das mais procuradas para residência familiar e segunda habitação. O mercado varia entre moradias de luxo com vista mar e apartamentos modernos em condomínios privados.',
    image: 'https://images.unsplash.com/photo-1585208798174-6cedd86e019a?w=1200&q=80',
    priceRange: 'Variado'
  },
  {
    id: 3,
    name: 'Costa Atlântica & Surf',
    description: 'A Costa Atlântica, que abrange Ericeira, Peniche e a costa de Óbidos, é hoje um destino de referência mundial para surf e lifestyle à beira-mar. Portugal atrai praticantes de surf todo o ano graças à consistência das suas ondas e à diversidade de picos. A região oferece vilas autênticas, gastronomia local e uma comunidade internacional vibrante.',
    image: 'https://images.unsplash.com/photo-1502933691298-84fc14542831?w=1200&q=80',
    priceRange: 'Em valorização'
  },
  {
    id: 4,
    name: 'Algarve',
    description: 'Destino de eleição para quem busca sol o ano inteiro, o Algarve oferece uma combinação única de praias paradisíacas, resorts de luxo e campos de golfe de renome mundial. Vilamoura, Quinta do Lago e Vale do Lobo são referências internacionais, com imóveis que vão de villas contemporâneas a condomínios exclusivos.',
    image: 'https://images.unsplash.com/photo-1646208951323-be9763169921?w=1200&q=80',
    priceRange: 'Premium'
  },
  {
    id: 5,
    name: 'Comporta & Alentejo',
    description: 'Autenticidade, privacidade e sofisticação definem a Comporta e o litoral alentejano. A região tornou-se um dos destinos mais exclusivos da Europa, onde arquitetura contemporânea dialoga com a simplicidade local. Aqui predominam moradias integradas na natureza, grandes lotes e projetos boutique que valorizam a paisagem e o estilo de vida descontraído.',
    image: 'https://images.unsplash.com/photo-1559827260-dc66d52bef19?w=1200&q=80',
    priceRange: 'Exclusivo'
  },
  {
    id: 6,
    name: 'Porto & Norte',
    description: 'O Porto e o Norte de Portugal oferecem uma combinação única de história, cultura e dinamismo económico. A cidade do Porto, classificada como Património Mundial pela UNESCO, é reconhecida internacionalmente. Nos bairros da Foz, da Boavista e do centro histórico, encontram-se imóveis de charme e projetos contemporâneos que valorizam o património e a modernidade.',
    image: 'https://images.unsplash.com/photo-1555881400-69a2384edcd4?w=1200&q=80',
    priceRange: 'Valorização'
  }
];

export const services = [
  {
    id: 1,
    title: 'Procura de imóveis',
    description: 'Tudo começa com uma conversa estruturada para compreender as suas necessidades: tipologia, localização, orçamento e estilo de vida. Realizamos uma pesquisa completa em todo o mercado, cruzando a oferta pública com a nossa rede exclusiva de parceiros.',
    icon: 'search'
  },
  {
    id: 2,
    title: 'Estratégia de compra',
    description: 'Apresentamos uma shortlist personalizada que é validada por si antes de passarmos à fase seguinte. Agendamento de visitas privadas, análise de valor de mercado, estratégia de oferta e negociação.',
    icon: 'target'
  },
  {
    id: 3,
    title: 'Negociação',
    description: 'Representamos exclusivamente o comprador, assegurando uma perspetiva imparcial e orientada para os seus interesses. Negociamos em seu nome para obter as melhores condições.',
    icon: 'handshake'
  },
  {
    id: 4,
    title: 'Gestão e administração',
    description: 'Administramos o seu imóvel, cuidando de todos os detalhes com discrição e eficiência. Desde a manutenção preventiva até à gestão de arrendamentos, assegurando que a sua propriedade se mantenha valorizada.',
    icon: 'briefcase'
  },
  {
    id: 5,
    title: 'Concierge pós-compra',
    description: 'Oferecemos, através de parceiros especializados, apoio em áreas como financiamento, abertura de conta bancária, apoio jurídico, gestão de obras, decoração, escolas internacionais e outros serviços de integração.',
    icon: 'gift'
  },
  {
    id: 6,
    title: 'Golden Visa e vistos',
    description: 'Trabalhamos com sociedades de advogados devidamente inscritas para dar suporte legal. Conectamos você com parceiros especializados para todas as necessidades relacionadas com imigração.',
    icon: 'globe'
  }
];

export const blogPosts = [
  {
    id: 1,
    title: 'FINANCIAMENTO BANCÁRIO PARA COMPRA DE IMÓVEIS EM PORTUGAL',
    excerpt: 'Se você está planejando comprar um imóvel em Portugal e precisa de apoio financeiro, o financiamento bancário é uma opção comum. No entanto, é importante entender como esse processo funciona no país.',
    category: 'Real Estate',
    image: 'https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=800&q=80',
    date: '2024-07-08'
  },
  {
    id: 2,
    title: 'AS REGIÕES DE PORTUGAL COM MAIOR VALORIZAÇÃO IMOBILIÁRIA EM 2022',
    excerpt: 'Portugal tem sido um destino cada vez mais popular para investidores imobiliários nos últimos anos, devido à sua beleza natural, qualidade de vida e ambiente amigável para negócios.',
    category: 'Real Estate',
    image: 'https://images.unsplash.com/photo-1579975324198-1b171d34dae6?w=800&q=80',
    date: '2024-07-08'
  },
  {
    id: 3,
    title: 'AS NOVAS REGRAS DO GOLDEN VISA EM PORTUGAL: O QUE VOCÊ PRECISA SABER',
    excerpt: 'A compra de imóveis deixou de ser elegível para o Golden Visa desde outubro de 2023 (Lei n.º 56/2023). Hoje, as vias possíveis incluem fundos qualificados, criação de emprego e apoio a atividades científicas e culturais.',
    category: 'Golden Visa',
    image: 'https://images.unsplash.com/photo-1582407947304-fd86f028f716?w=800&q=80',
    date: '2024-07-08'
  }
];

export const testimonials = [
  {
    id: 1,
    text: 'Recomendo a Your Broker Portugal para quem procura excelência no mercado imobiliário português',
    author: 'Carlos M.',
    role: 'Empresário'
  },
  {
    id: 2,
    text: 'Profissionalismo e dedicação incomparáveis. Encontraram exatamente o que procurávamos.',
    author: 'Ana S.',
    role: 'Investidora'
  },
  {
    id: 3,
    text: 'A equipa acompanhou-nos em todo o processo com transparência total',
    author: 'Roberto L.',
    role: 'Médico'
  },
  {
    id: 4,
    text: 'O valor agregado que a Your Broker traz superou nossas expectativas',
    author: 'Patricia F.',
    role: 'Arquiteta'
  }
];